import React from 'react';
interface ProgressBarProps {
  current: number;
  total: number;
}
export function ProgressBar({
  current,
  total
}: ProgressBarProps) {
  const progress = Math.min(100, Math.max(0, current / (total - 1) * 100));
  return <div className="w-full bg-stone-200 h-2 rounded-full overflow-hidden" role="progressbar" aria-valuenow={progress} aria-valuemin={0} aria-valuemax={100} data-id="element-242">
      <div className="h-full bg-amber-600 transition-all duration-500 ease-out" style={{
      width: `${progress}%`
    }} data-id="element-243" />
    </div>;
}